/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import { graphql } from 'gatsby'

// Elements
import HeroAlt from 'components/elements/HeroAlt'
import ButtonDefault from 'components/elements/ButtonDefault'

// Components
import ParseContent from 'components/shared/ParseContent'
import SEO from 'components/shared/SEO'
import Layout from 'components/layout/Layout'

import styled from 'styled-components'

const Content = styled(ParseContent)`
  font-family: ${props => props.theme.font.family.secondary};
  color: ${props => props.theme.color.text.main};

  & a {
    color: ${props => props.theme.color.text.third};
    font-weight: ${props => props.theme.font.weight.l};
  }
`

const VideoWrapper = styled.div`
 position: relative;
  width: 100%;
  padding-top: 56.25%; /* 9 / 16 * 100 */

  @media screen and (min-width: 767px) {
    padding-top: 47.25%;
  }

  & iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }
`

const Row = styled.div`
  @media (max-width: 991px){
    margin-left: 15px !important;
    margin-right: 15px !important;
  }
`

const PdfLink = styled.a`
  background-color: ${props => props.theme.color.face.contrast};
  display: inline-block;
  border-radius: 25.5px;
  color: ${props => props.theme.color.text.secondary};
  padding: 13.5px 35px;
  width: 100%;
  height: 100%;
text-align: center;
  font-family: ${props => props.theme.font.family.secondary};
  font-weight: ${props => props.theme.font.weight.xl};

  &:hover {
    color: ${props => props.theme.color.text.secondary};
    text-decoration: none;
  }
`

const PageTemplate = ({
  data: {
    page: { path, yoast_meta: yoast, acf },
  },
}) => {
  return (
    <Layout extraSpacing >
      <SEO yoast={yoast} path={path} />

      <HeroAlt fields={acf.banner} />

      <section>
        <div className='container py-lg-3'>
            <div className='row py-3 py-lg-5'>
                <div className='col-12'>
                    <Content content={acf.description} className="mb-4" />
                </div>
            </div>
        </div>
      </section>

      <section>
        <div className='container'>
            <Row className='row justify-content-center'>
                <VideoWrapper className='col-12 col-md-10 text-center'>
                    <iframe src={acf.vimeo_url}  frameBorder="0" allowFullScreen title="Top 20"></iframe>
                </VideoWrapper>
                <div className='col-12 col-md-10 text-center mt-4'>
                  <iframe
                    src="/pdf/top-100.pdf"
                    width="100%"
                    height="800"
                    style={{ border: 'none' }}
                    title="PDF viewer"
                    className='d-none d-lg-block'
                  />
                </div>
                <PdfLink href="/pdf/top-100.pdf" target="_blank" className='btn-default d-lg-none' rel="noreferrer">Bekijk de Top 100 lijst</PdfLink>

            </Row>
        </div>
      </section>

      <section>
        <div className='container py-lg-3'>
            <div className='row py-4 py-lg-5'>
                <div className='col-12'>
                    <Content content={acf.content_below} className="mb-4" />
                </div>
            </div>
        </div>
      </section>

    </Layout>
  )
}

export const pageQuery = graphql`
  query($wordpress_id: Int) {
    page: wordpressPage(wordpress_id: { eq: $wordpress_id }) {
      ...topTwentyPageFragment
    }
  }
`

export default PageTemplate
